// Apps that sign in through GreenBless. The login token is only ever sent back to these origins,
// so a crafted ?return_to= link cannot carry it anywhere else.
const RETURN_ORIGINS = [
    'https://test.octopus.rnrobots.cloud',
    'https://octopus.rnrobots.cloud',
    'http://localhost:5173', // the Octopus dashboard in development
];

// On the login page: remember where to go back to, for this tab only.
export const saveReturnTo = (search = window.location.search) => {
    const target = new URLSearchParams(search).get('return_to');
    let allowed = false;
    try {
        allowed = !!target && RETURN_ORIGINS.includes(new URL(target).origin);
    } catch {
        allowed = false; // not a URL
    }
    if (allowed) sessionStorage.setItem('return_to', target);
    else sessionStorage.removeItem('return_to');
};

// After signing in: go back to the app that sent the user here, with the token in the URL fragment,
// which the browser never sends to a server. False when there is nowhere to go back to.
export const leaveForReturnTo = () => {
    const target = sessionStorage.getItem('return_to');
    const token = localStorage.getItem('AuthToken');
    if (!target || !token) return false;
    sessionStorage.removeItem('return_to');
    window.location.href = `${target}#token=${encodeURIComponent(token)}`;
    return true;
};
